/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import http from "../http-common";

const controller = "/hvacmakes";
const hvacMakesService = {
    getmakesmodels: async (type) => {
        const response = await http.get(`${controller}/getmakesmodels`);
        return response.data;
    }
};
export default hvacMakesService;